import InfoIcon from '@mui/icons-material/Info';
import LogoutIcon from '@mui/icons-material/Logout';
import MailIcon from '@mui/icons-material/Mail';
import SettingsIcon from '@mui/icons-material/Settings';
import { AppBar, Box, Button, CssBaseline, Toolbar, Typography, useTheme } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useBrand } from '../contexts/BrandContext';

export const MainLayout = () => {
  const { logout, userRole } = useAuth();
  const { brandConfig, logo } = useBrand();
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', width: '100%' }}>
      <CssBaseline />
      <AppBar
        position="static"
        sx={{
          background: theme.brand?.gradient || theme.palette.primary.main,
        }}
      >
        <Toolbar>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexGrow: 1 }}>
            <img src={logo} alt={brandConfig.name} style={{ height: '32px', width: '32px' }} />
            <Typography variant="h6" component="div">
              {brandConfig.name}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Button
              color="inherit"
              startIcon={<MailIcon />}
              onClick={() => navigate('/threads')}
              sx={{
                textTransform: 'none',
                bgcolor: location.pathname.startsWith('/threads') ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
                '&:hover': {
                  bgcolor: 'rgba(255, 255, 255, 0.1)',
                },
              }}
            >
              問い合わせ一覧
            </Button>
            <Button
              color="inherit"
              startIcon={<InfoIcon />}
              onClick={() => navigate('/tenants')}
              sx={{
                textTransform: 'none',
                bgcolor: location.pathname === '/tenants' ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
                '&:hover': {
                  bgcolor: 'rgba(255, 255, 255, 0.1)',
                },
              }}
            >
              {brandConfig.tenantLabel}一覧
            </Button>
            {(userRole === 'admin' || userRole === 'staff') && (
              <Button
                color="inherit"
                startIcon={<SettingsIcon />}
                onClick={() => navigate('/settings')}
                sx={{
                  textTransform: 'none',
                  bgcolor: location.pathname === '/settings' ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
                  '&:hover': {
                    bgcolor: 'rgba(255, 255, 255, 0.1)',
                  },
                }}
              >
                設定
              </Button>
            )}
            <Button
              color="inherit"
              startIcon={<LogoutIcon />}
              onClick={() => logout()}
              sx={{
                textTransform: 'none',
                '&:hover': {
                  bgcolor: 'rgba(255, 255, 255, 0.1)',
                },
              }}
            >
              ログアウト
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>
    </Box>
  );
};
